import animation from '@helpers/animation';
import brand from '@helpers/brand';
import { cssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { m } from 'framer-motion';
import srOnly from '@helpers/srOnly';
import { ReactComponent as SvgSearch } from '@img/icons/search-icon.svg';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) ``;
const ItemList = styled(m.div) `
  display: grid;
  gap: 24px 16px;
  grid-template-columns: repeat(12, 1fr);

  @media ${from(Device.TabletLarge)} {
    gap: 64px 40px;
  }
`;
const Item = styled(m.div) `
  grid-column: span 12;

  @media ${from(Device.Tablet)} {
    grid-column: span 6;
  }

  @media ${from(Device.TabletLarge)} {
    grid-column: span 4;
  }
`;
const SearchResult = styled.span `
  ${fonts.matter.regular};
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 10px;

  @media ${from(Device.Tablet)} {
    font-size: 22px;
    line-height: 32px;
    margin-bottom: 30px;
  }
`;
const Highlight = styled.span `
  ${fonts.matter.medium};
`;
const SearchContainer = styled.div `
  position: relative;
  max-width: 100%;
  margin: 0;
  display: flex;

  @media ${from(Device.Tablet)} {
    max-width: 441px;
  }

  @media ${from(Device.DesktopSmall)} {
    max-width: 860px;
  }
`;
const Input = styled.input `
  ${fonts.matter.regular};
  display: block;
  flex: 1 0 auto;
  max-width: 860px;
  background: ${brand.white};
  border-radius: 5px;
  border: 1px solid ${brand.sage.sageLight};
  color: ${brand.sage.sageLight};
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  outline: none;
  padding: 13px 50px 13px 10px;

  @media ${from(Device.Tablet)} {
    padding: 12px 60px 12px 10px;
    font-size: 16px;
    line-height: 24px;
  }

  @media ${from(Device.Desktop)} {
    min-width: 400px;
  }

  &:focus {
    outline: none;
  }

  &.focus-visible {
    border-color: ${cssVar('fgColor')};
  }
`;
const Submit = styled.button `
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  align-content: center;
  align-items: center;
  background-color: ${brand.sage.sageLight};
  border: none;
  color: ${brand.white};
  flex: 0 0 45px;
  height: 45px;
  padding: 5px;
  justify-content: center;
  justify-items: center;
  width: 46px;
  border-radius: 0 3px 3px 0;
  transition: background-color 0.3s ${animation.secondary};

  @media ${from(Device.Tablet)} {
    height: 50px;
    width: 57px;
    padding: 10px;
  }

  &:focus {
    outline: none;
  }

  &:focus,
  &:hover {
    background-color: ${brand.sage.sageDark};
  }
`;
const SubmitLabel = styled.span `
  ${srOnly}
`;
const SubmitIcon = styled(SvgSearch) `
  display: block;
  color: currentColor;
  height: 33px;
  width: 33px;
  transition: background-color 0.3s;
`;
export default {
    Container,
    Highlight,
    Input,
    Item,
    ItemList,
    SearchContainer,
    Submit,
    SubmitIcon,
    SubmitLabel,
    SearchResult,
};
